import { render, staticRenderFns } from "./BasicInfoDetailCard.vue?vue&type=template&id=f3643f72&scoped=true"
import script from "./BasicInfoDetailCard.vue?vue&type=script&lang=js"
export * from "./BasicInfoDetailCard.vue?vue&type=script&lang=js"
import style0 from "./BasicInfoDetailCard.vue?vue&type=style&index=0&id=f3643f72&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3643f72",
  null
  
)

export default component.exports